import { postRequest } from "../../api";

export const createFeedback = (payload) => {
    return postRequest("/feedback/create", payload);
}